import axios from 'axios';
import {backendHost} from '../../config';

export const getMailingStatisticsDashboard = (params) => {
    return axios.get(`${backendHost}/api/admin/v2/mailing/statistics/currency/list`, {params});
};